import AboutVilla from '../../components/AboutVilla/AboutVilla';

function MainPage() {
  return <AboutVilla />;
}

export default MainPage;
